<div class="container-spinner">
  <div class="spinner-grow background-blue" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <span class="color-blue">Cargando...</span>
</div>
